<div class="mtest-medical-test-download-icons d-flex align-items-center">
  <si-selector-icon iconClass="pasi-icon {{iconStyleClass}}"
                    iconText="SI_DOWNLOAD_REPORT"
                    [items]="optionDownloadValues"
                    [hideOnEmpty]="true"
                    [openTop]="openTop"
                    (modelChange)="onSelectDownloadOption($event)"
  ></si-selector-icon>
  <si-selector-icon icon="icosun-images"
                    iconClass="pasi-icon {{iconStyleClass}}"
                    iconText="SI_VIEW_IMAGE"
                    [items]="optionImageValues"
                    styleClass="ml-1"
                    [hideOnEmpty]="true"
                    [openTop]="openTop"
                    (modelChange)="onSelectDownloadOption($event)"
  ></si-selector-icon>
  <ng-container *siSecure="['document_management:share']">
    <si-selector-icon icon="icosun-share_files"
                      iconClass="pasi-icon {{iconStyleClass}}"
                      iconText="SI_SHARE"
                      [items]="optionShareValues"
                      styleClass="ml-1"
                      [hideOnEmpty]="true"
                      [openTop]="openTop"
                      (modelChange)="onSelectShareOption($event)"
    ></si-selector-icon>
  </ng-container>
</div>

<ng-container *ngIf="displayShareDialog">
  <si-share-dialog [(displayDialog)]="displayShareDialog"
                   dialogTitle="SI_SHARE_DOCUMENT"
                   [dialogText]="shareDialogOption?.name"
                   [url]="shareDialogData?.url"
                   [pin]="shareDialogData?.pin"
                   [expirationTime]="shareDialogData?.expirationTime"
  ></si-share-dialog>
</ng-container>
